<ng-template #defaultItemTemplate let-item="item">{{item[labelKey]}}</ng-template>
<ul #list class="dropdown-menu scrollable-menu" [hidden]="hidden" [class.mention-menu]="!styleOff" [ngClass]="{'mention-menu-ccu': isCCU}"
  [class.mention-dropdown]="!styleOff && dropUp">
  @for (item of items; track item; let i = $index) {
    @if (currentItemGroup !== item[groupKey]) {
      <li class="dropdown-header" (mousedown)="$event.preventDefault()" [attr.aria-label]="item[groupKey]">
        {{ groupLabels[item[groupKey]] }}
        <ng-container>{{updateCurrentItemGroup(item[groupKey])}}</ng-container>
      </li>
    }
    <li class="dropdown-item" [class.active]="activeIndex === i"
      [class.mention-active]="!styleOff && activeIndex === i">
      <a [class.mention-item]="!styleOff" (mousedown)="activeIndex = i; itemClick.emit(item); $event.preventDefault()">
        <ng-template [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{'item': item}"></ng-template>
      </a>
    </li>
  }
</ul>